// eslint-disable-next-line import/prefer-default-export
export const getClientID = async () => {
    if (!window.ym) {
        return "";
    }

    return new Promise((resolve) => {
        window.ym(23182390, "getClientID", (clientID) => {
            resolve(clientID);
        });
    });
};
